import styled from 'styled-components';

import { COLOR_1 } from '../../../config';
import { backgroundSideBar, col_error } from '../../../globals';


export const StyledCheckBox = styled.div`
  padding: 0 6px 0 6px;
  margin: 2px 0 15px 0;

  /* The container */
  .container {
      display: block;
      position: relative;
      padding-left: 30px;
      padding-right: 0;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      font-weight: normal;
  }

  /* Hide the browser's default checkbox */
  .container input {
      position: absolute;
      opacity: 0;
      
  }

  /* Create a custom checkbox */
  .checkmark {
    cursor: pointer;
      position: absolute;
      top: 0;
      left: 0;
      height: 20px;
      width: 20px;
  }

  /* When the checkbox is checked, add a blue background */
  .checkmark {
      background-color: ${COLOR_1};
  }

  .checkmark.error {
      background-color: ${col_error};
  }


  /* On mouse-over, add a grey background color */
  .checkmark:hover {
      background-color: ${backgroundSideBar};
  }

  /* Create the checkmark/indicator (hidden when not checked) */
  .checkmark:after {
      content: "";
      position: absolute;
      display: none;
  }

  /* Show the checkmark when checked */
  .container input:checked ~ .checkmark:after {
      display: block;
  }

  /* Style the checkmark/indicator */
  .container .checkmark:after {
      left: 7px;
      top: 4px;
      width: 6px;
      height: 10px;
      border: solid white;
      border-width: 0 3px 3px 0;
      -webkit-transform: rotate(45deg);
      -ms-transform: rotate(45deg);
      transform: rotate(45deg);
  }
`;



// WEBPACK FOOTER //
// ./src/common/CheckBox/styles/StyledCheckBox.js